(() => {
  const generatedMessages = new WeakMap();
  const restoredQueries = new WeakMap();
  function closeMenu(menu, restoreFocus = false) {
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary')?.focus({ preventScroll: true });
  }
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.patri-mobile-menu[open]').forEach(menu => {
      const navigationLink = event.target.closest('a[href]');
      if (!menu.contains(event.target)) {
        closeMenu(menu, menu.contains(document.activeElement));
      } else if (navigationLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        closeMenu(menu, true);
      }
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.patri-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) closeMenu(menu);
    });
  });
  function updateIdea(form, idea, preserveReference = false) {
    if (!form) return;
    const reference = form.querySelector('[data-patri-reference]');
    if (!reference) return;
    idea = preserveReference && reference.value.trim() ? reference.value : idea;
    reference.value = idea;
    const selection = form.querySelector('[data-patri-selection]');
    const selectedName = form.querySelector('[data-patri-selection-name]');
    if (selectedName) selectedName.textContent = idea;
    if (selection) selection.hidden = !idea.trim();
    if (reference.hasAttribute('data-patri-business-reference')) return;
    const message = form.querySelector('[data-patri-message]');
    if (!message) return;
    const previous = generatedMessages.get(message);
    const generated = idea ? idea + '\n' : '';
    if (!message.value.trim()) {
      message.value = generated;
      generatedMessages.set(message, generated);
    } else if (previous && message.value.startsWith(previous)) {
      message.value = generated + message.value.slice(previous.length);
      generatedMessages.set(message, generated);
    }
  }
  function openQuote(target, idea, focus = false, preserveReference = false) {
    if (!target) return;
    if (target.tagName === 'DETAILS') target.open = true;
    if (idea) {
      updateIdea(target.querySelector('.patri-contact-form'), idea, preserveReference);
    }
    if (focus) target.querySelector('summary')?.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    if (!anchor) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const destination = new URL(anchor.href, location.href);
    if (destination.pathname !== location.pathname || destination.origin !== location.origin) return;
    const quote = document.querySelector('.patri-quote');
    if (quote && (anchor.hasAttribute('data-patri-open') || anchor.hasAttribute('data-patri-idea') || destination.hash === '#contacto')) {
      event.preventDefault();
      document.querySelectorAll('.patri-mobile-menu[open]').forEach((menu) => { menu.open = false; });
      history.replaceState(null, '', '#contacto');
      openQuote(quote, anchor.dataset.patriIdea, true);
    }
  });
  function restoreQuote() {
    const quote = document.querySelector('.patri-quote') || document.querySelector('[data-patri-business-quote]');
    if (!quote) return;
    const params = new URLSearchParams(location.search);
    const requestedIdea = params.get('cotizar')?.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 300) ?? null;
    const idea = restoredQueries.get(quote) === requestedIdea ? null : requestedIdea;
    restoredQueries.set(quote, requestedIdea);
    if (location.hash === '#contacto' || location.hash === '#cotizar' || location.hash.startsWith('#Patri') || idea || params.get('contact_posted') === 'true' || quote.querySelector('.patri-form-errors,.patri-form-message')) openQuote(quote, idea, false, true);
  }
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-patri-reference]')) updateIdea(event.target.closest('.patri-contact-form'), event.target.value);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !event.defaultPrevented) document.querySelectorAll('.patri-mobile-menu[open]').forEach((menu) => { closeMenu(menu, true); });
  });
  window.addEventListener('hashchange', restoreQuote);
  document.addEventListener('shopify:section:load', restoreQuote);
  restoreQuote();
})();
